import { render, staticRenderFns } from "./StockTransferForm.vue?vue&type=template&id=0955da5a"
import script from "./StockTransferForm.vue?vue&type=script&lang=js"
export * from "./StockTransferForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports